import { render, staticRenderFns } from "./AppDetalhes.vue?vue&type=template&id=3cdfbbdb&scoped=true&"
import script from "./AppDetalhes.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppDetalhes.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AppDetalhes.vue?vue&type=style&index=0&id=3cdfbbdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdfbbdb",
  null
  
)

export default component.exports